//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { inputMaskProcessor } from './InputMaskProcessor.js'

export default {
  name: 'DurationField',
  components: {
  },
  mixins: [inputMaskProcessor],
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    modelType: {
      type: String,
      default: 'text' // text, millis
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: null
    },
    iconTooltip: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: undefined
    },
    format: {
      type: String,
      default: null
    },
    debounce: {
      type: Number,
      default: 0
    },

    withMilliseconds: {
      type: Boolean,
      default: false
    },
    confirmBtns: {
      type: Boolean,
      default: true // TODO продумать, как сделать иначе. Например, делать последовательную фокусировку на полях времени, а при клике на последнее (минуты или секунды) закрывать попап и применять значение
    }
  },
  data: function () {
    return {
      textValue: ''
    }
  },
  computed: {
    formatConfig: function () {
      let format = 'DD дн. HH:mm:ss.SSS' // TODO this.format
      let withMilliseconds = this.withMilliseconds
      if (!format) {
        format = withMilliseconds ? 'DD дн. HH:mm:ss.SSS' : 'DD дн. HH:mm:ss'
      } else {
        withMilliseconds = !!format.includes('.SSS')
      }

      const formatConfig = {
        format,
        withMilliseconds,
        mask: format.replaceAll(/[a-z]/gi, '#')
      }

      let formatPlaceholder = format
      formatConfig.millis = format.includes('SSS')
      if (formatConfig.millis) {
        formatPlaceholder = formatPlaceholder.replaceAll('SSS', 'ССС')
      }
      formatConfig.seconds = format.includes('ss')
      if (formatConfig.seconds) {
        formatPlaceholder = formatPlaceholder.replaceAll('ss', 'cc')
      }
      formatConfig.minutes = format.includes('mm')
      if (formatConfig.minutes) {
        formatPlaceholder = formatPlaceholder.replaceAll('mm', 'мм')
      }
      formatConfig.hours = format.includes('HH')
      if (formatConfig.hours) {
        formatPlaceholder = formatPlaceholder.replaceAll('HH', 'чч')
      }
      formatConfig.date = format.includes('DD')
      if (formatConfig.date) {
        formatPlaceholder = formatPlaceholder.replaceAll('DD', 'дд')
      }
      formatConfig.month = format.includes('MM')
      if (formatConfig.month) {
        formatPlaceholder = formatPlaceholder.replaceAll('MM', 'мм')
      }
      formatConfig.year = format.includes('YY')
      if (formatConfig.year) {
        formatPlaceholder = formatPlaceholder.replaceAll('YY', 'гг')
      }
      formatConfig.placeholder = formatPlaceholder

      return formatConfig
    },
    placeholderLocal: function () {
      if (this.placeholder != null) {
        return this.placeholder
      } else if (this.formatConfig.placeholder) {
        return this.formatConfig.placeholder
      }
      return null
    },
    hasError: function () {
      return !!this.$refs.field && this.$refs.field.hasError
    },
    empty: function () {
      return this.textValue == null || this.textValue === ''
    }
  },
  watch: {
    value: {
      handler: function (value) {
        if (this.modelType === 'millis') {
          this.textValue = this.formatMillis(value) || ''
        } else {
          this.textValue = value || ''
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    this.applyInputMaskProcessor('field')
  },
  methods: {
    formatMillis: function (millis) {
      if (millis) {
        const days = Math.floor(millis / 86400000)
        let diff = millis - days * 86400000
        let hours = Math.floor(diff / 3600000)
        diff -= hours * 3600000
        let minutes = Math.floor(diff / 60000)
        diff -= minutes * 60000
        let seconds = Math.floor(diff / 1000)
        diff -= seconds * 1000
        let milliseconds = diff - seconds * 1000

        hours = ('0' + hours).slice(-2)
        minutes = ('0' + minutes).slice(-2)
        seconds = ('0' + seconds).slice(-2)
        milliseconds = ('000' + milliseconds).slice(-4)

        const textValue = `${days} дн. ${hours}:${minutes}:${seconds},${milliseconds}`
        return textValue
        // return new Intl.DurationFormat('ru', { style: 'digital' }).format({
        //   days,
        //   hours,
        //   minutes,
        //   seconds,
        //   milliseconds
        // })
      }
      return null
    },

    parseMillis (value) { // TODO не проверено
      if (value) {
        const matchResult = value.match(/^(\d*) дн. (\d{2}):(\d{2}):(\d{2}),(\d{4})»$/)
        if (matchResult) {
          const days = Number(value[0])
          const hours = Number(value[1])
          const minutes = Number(value[2])
          const seconds = Number(value[3])
          const milliseconds = Number(value[4])

          const millis = days * 86400000 + hours * 3600000 + minutes * 60000 + seconds * 1000 + milliseconds
          return millis
        }
      }
      return null
    },

    // ===

    onInput: function (textValue) {
      this.setValue(textValue)
    },
    setValue: function (textValue) {
      let value
      if (this.modelType === 'millis') {
        value = textValue ? this.parseMillis(textValue) : null
      } else {
        value = textValue
      }

      this.emitValue(value)
    },

    // ===

    onClear: function () {
      if (this.readonly) {
        return
      }

      this.emitValue(null)
      this.$emit('clear')
    },
    emitValue: function (value = null) {
      this.$emit('input', value)
    },
    validate: function () {
      return this.$refs.field.validate()
    }
  }
}
